import React, {FC} from 'react';
import classNames from 'classnames';

import * as styles from './styles.module.scss';

type MediaQueryProps = {
	className?: string;
	desktop?: boolean;
	mobile?: boolean;
	children: React.ReactNode;
}

const MediaQuery: FC<MediaQueryProps> = ({
	className,
	desktop = false,
	mobile = false,
	children,
}) => {
	const cn = (desktop: boolean) => (
		classNames({
			[className || '']: Boolean(className),
			[styles.desktop]: desktop,
			[styles.mobile]: !desktop,
		})
	);

	if (desktop === mobile) {
		return null;
	} else if (desktop) {
		return <div className={cn(true)}>{children}</div>;
	} else if (mobile) {
		return <div className={cn(false)}>{children}</div>;
	}
	return null;
};

export default MediaQuery;
